// client/src/dnd/emitter_tool/runtime/Runtime_Parts/fogHelpers.js

/* ---------- fog holes helpers (robust to Application OR Container) ---------- */
export function getRootContainer(app) {
  if (!app) return null;
  // PIXI.Application ⇒ use .stage; otherwise if a Container was passed, use it
  if (app.stage && typeof app.stage.addChild === "function") return app.stage;
  if (typeof app.addChild === "function") return app; // root container
  return null;
}

/** Locate the fog "holes" container created by fog.js (FogComposite → FogFeatheredLayer → FogHoles) */
export function findFogHoles(root) {
  if (!root?.getChildByName) return null;
  const fogComposite = root.getChildByName("FogComposite");
  if (!fogComposite?.getChildByName) return null;
  const feathered = fogComposite.getChildByName("FogFeatheredLayer");
  const holes = feathered?.getChildByName?.("FogHoles");
  return holes || null;
}
